// One password rule for every screen that sets a password (create user, admin reset, profile
// change, first-login setup). Mirrors ipri-backend/src/utils/passwordPolicy.js — change both.

export interface PasswordRule { key: string; label: string; test: (pw: string) => boolean }

export const PASSWORD_RULES: PasswordRule[] = [
  { key: 'length', label: 'At least 12 characters', test: (pw) => pw.length >= 12 },
  { key: 'upper', label: 'One uppercase letter', test: (pw) => /[A-Z]/.test(pw) },
  { key: 'lower', label: 'One lowercase letter', test: (pw) => /[a-z]/.test(pw) },
  { key: 'digit', label: 'One number', test: (pw) => /[0-9]/.test(pw) },
];

// The rules the password fails, in display order; empty means it passes.
export const passwordProblems = (pw: string): PasswordRule[] => PASSWORD_RULES.filter((r) => !r.test(pw));

// A temporary password an admin can hand over: 16 characters from an alphabet without look-alike
// glyphs (no 0/O, 1/l/I), with at least one of each required class guaranteed.
export function generateTemporaryPassword(length = 16): string {
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lower = 'abcdefghijkmnopqrstuvwxyz';
  const digits = '23456789';
  const all = upper + lower + digits;
  const pick = (chars: string) => chars[crypto.getRandomValues(new Uint32Array(1))[0] % chars.length];
  const out = [pick(upper), pick(lower), pick(digits)];
  while (out.length < length) out.push(pick(all));
  // shuffle so the guaranteed characters aren't always first
  for (let i = out.length - 1; i > 0; i--) {
    const j = crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1);
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out.join('');
}
